module.exports = __webpack_public_path__ + "0196ce44813461b78a0b5f463f12553c.pdf";